export const AI_TRAINER_PERSONALITIES = [
	{
		id: 'accountability_partner',
		label: 'Accountability Partner',
		emoji: '🤝',
		tagline: 'Collaborative. Asks the right questions.',
		sampleLine: "What's one thing you can knock out in the next hour?"
	},
	{
		id: 'tough_love',
		label: 'Tough Love',
		emoji: '🥊',
		tagline: 'Gloves off. No excuses.',
		sampleLine: 'You committed. Now finish it.'
	},
	{
		id: 'drill_sergeant',
		label: 'Drill Sergeant',
		emoji: '🎖️',
		tagline: 'Hard core. Zero tolerance.',
		sampleLine: 'Move. Now. Execute.'
	},
	{
		id: 'soft_spoken',
		label: 'Soft Spoken',
		emoji: '🌿',
		tagline: 'Gentle. Steady. Encouraging.',
		sampleLine: "Small steps still count. You've got this."
	},
	{
		id: 'hype_coach',
		label: 'Hype Coach',
		emoji: '🔥',
		tagline: 'High energy. Celebrate wins.',
		sampleLine: "LET'S GO — one more rep toward your goal!"
	},
	{
		id: 'science_nerd',
		label: 'Science Nerd',
		emoji: '🧬',
		tagline: 'Evidence first. Mechanism always.',
		sampleLine: 'Even 1–2% dehydration impairs performance — hydrate now.'
	}
];

export const OPENAI_DISCLOSURE =
	'Your messages are processed by OpenAI to generate coaching responses. Do not share sensitive medical information.';
